import { render, staticRenderFns } from "./social-share-bookmark.vue?vue&type=template&id=0cd5f62a&scoped=true"
import script from "./social-share-bookmark.vue?vue&type=script&lang=js"
export * from "./social-share-bookmark.vue?vue&type=script&lang=js"
import style0 from "./social-share-bookmark.vue?vue&type=style&index=0&id=0cd5f62a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cd5f62a",
  null
  
)

export default component.exports